import { render, staticRenderFns } from "./work-advanced-selector.vue?vue&type=template&id=1b3b5656&"
import script from "./work-advanced-selector.vue?vue&type=script&lang=js&"
export * from "./work-advanced-selector.vue?vue&type=script&lang=js&"
import style0 from "./work-advanced-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports